import { useEffect, useRef, useState } from 'react';

import classNames from 'classnames';
import isInteger from 'lodash/isInteger';

import { SocialCoin } from '../../../components/SocialCoin/SocialCoin';
import { SweepCoin } from '../../../components/SweepCoin/SweepCoin';

import classes from './BonusProgress.module.scss';

function formatNumber(num: number) {
  const decimalDigits = isInteger(num) ? 0 : 1;
  if (num >= 1000) {
    return (num / 1000).toFixed(decimalDigits) + 'K';
  } else {
    return num.toFixed(decimalDigits).toString();
  }
}

export function MonthlyBonusTooltip(props: { day: number; gc: number; sc: number; onClose?: () => void }) {
  const [isVisible, setIsVisible] = useState(true);
  let nextTooltipCls = '';
  switch (props.day) {
    case 8: {
      nextTooltipCls = classes.gift_8;
      break;
    }
    case 15: {
      nextTooltipCls = classes.gift_15;
      break;
    }
    case 22: {
      nextTooltipCls = classes.gift_22;
      break;
    }
    case 30: {
      nextTooltipCls = classes.gift_30;
      break;
    }
  }

  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();
  const innerTimeoutRef = useRef<ReturnType<typeof setTimeout>>();
  useEffect(() => {
    setIsVisible(true);
    timeoutRef.current = setTimeout(() => {
      setIsVisible(false);
      innerTimeoutRef.current = setTimeout(() => {
        props?.onClose?.();
      }, 1000);
    }, 1500);

    return () => {
      clearTimeout(timeoutRef.current);
      clearTimeout(innerTimeoutRef.current);
    };
  }, [props]);

  return (
    <div
      className={classNames(
        classes.giftTooltip,
        'onboarding-arrow',
        props.day > 15 && classes.right,
        isVisible ? 'fadeInTop' : 'fadeOutTop',
        nextTooltipCls,
      )}
    >
      <div className={classes.tooltipContent}>
        <SocialCoin className={classes.tooltipIconWidth} />
        <span>{formatNumber(props.gc)}</span>
        {' + '}
        <SweepCoin className={classes.tooltipIconWidth} />
        <span>{formatNumber(props.sc)}</span>
      </div>
    </div>
  );
}
